export default __webpack_public_path__ + "fed9a9043777aa322a6e9e730ac44f02.xlsx";